import React, { FC } from 'react';

import { Flex } from '@rover/kibble/core';
import Section from '@rover/kibble/patterns/Section';
import { FontWeight, FooterTheme, MQ, Spacing } from '@rover/kibble/styles';
import { useTheme } from '@rover/kibble/themes';
import { VerticalLayout } from '@rover/react-lib/src/components/layouts';
import useDeviceContext from '@rover/react-lib/src/context/useDeviceContext';
import usePageContext from '@rover/react-lib/src/context/usePageContext';
import useFooterShim from '@rover/shared/js/hooks/useFooterShim';

import MarketingSocial from './Marketing/MarketingSocial';
import Copyright from './Copyright';
import FooterLinks from './FooterLinks';

const Footer: FC = () => {
  const theme = useTheme();
  const { footerTheme = FooterTheme.LIGHT, suppressFooter } = usePageContext();
  const { footer } = useFooterShim();
  const { isEmbedded } = useDeviceContext();

  if (suppressFooter || !footer) return null;

  return (
    <Flex
      as="footer"
      backgroundColor={theme.background.secondary}
      theme={footerTheme}
      role="contentinfo"
      display={isEmbedded ? 'none' : 'block'}
    >
      <Section
        my="4x"
        sx={{
          [MQ.XS.toString()]: {
            h4: {
              fontWeight: FontWeight.BOLD.toString(),
              marginBottom: Spacing.S.toString(),
            },
          },
        }}
      >
        <VerticalLayout>
          <FooterLinks />
        </VerticalLayout>
        <MarketingSocial />
        <Copyright />
      </Section>
    </Flex>
  );
};

export default Footer;
